// extracted by mini-css-extract-plugin
export default {"ellipsis":"styles_ellipsis__YmKPu"};